import { logoutServices } from '@/utils';
import { useEffect } from 'react';

export const ResetRoute = () => {
  useEffect(() => {
    Promise.resolve(logoutServices()).then(
      () => (window.location.href = '/auth/login'),
    );
  }, []);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Resetting...</h1>
        <p className="text-gray-600">
          Please wait while we reset your session.
        </p>
      </div>
    </div>
  );
};
